import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  startAddHistorialOrdenPago,
  startGetOrdenPagoItemsXLS,
  startDownloadDocumentoOP,
  startMarcarEstatus
} from '../../../../context/actions/ordenesPagoActions';
import { startGetTareasOp } from '../../../../context/actions/tareasOpActions';
import {
  startEnviarOpPorEmail,
  startAutorizaOPv2,
  startAutorizaOP2v2,
  startAutorizaOP3v2,
  startAvanzarPagoDirectoOP,
  startValidarDocumentos,
  startAddOrdenPagoRowAndReload,
  startDeleteOrdenPagoRowAndReload,
  startUpdateEstadoPago,
  startDownloadCSF,
  startDownloadCaratula,
  startRegresoFlujoOp,
  startDownloadOPv2,
  startGetOrdenPagoV2,
  startDescargarDocumentoConcesionados,
  startEliminarOP,
  startSetOpArchivado,
  startSetClienteEnOp,
  startAdminStatusOverride,
  startUpdateOrdenPagoRowAndReload,
  startSetAnaliticaOdoo
} from '../../../../context/actions/pagos2Actions';
import { getTimeline } from '../../../../utils/pagoTimelineMapper';
import { useReloadAfterAction } from '../../../../hooks/useReloadAfterAction';

export const usePagoDetalle = (ordenPagoID) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading: loadingAutorizaciones, executeWithReload } = useReloadAfterAction(ordenPagoID);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const { ordenPago, ordenPagoItems } = useSelector(
    (state) => state.ordenesPagoReducer
  );
  const { usuarioID } = useSelector((state) => state.userReducer.user);

  const [nuevoComentario, setNuevoComentario] = useState('');
  const [notificarRedProveedores, setNotificarRedProveedores] = useState(false);
  const [modalEmailVisible, setModalEmailVisible] = useState(false);
  const [modalFacturaVisible, setModalFacturaVisible] = useState(false);
  const [modalValidarFacturaVisible, setModalValidarFacturaVisible] = useState(false);
  const [modalComplementoVisible, setModalComplementoVisible] = useState(false);
  const [modalXLSXPagoVisible, setModalXLSXPagoVisible] = useState(false);
  const [modalPDFPagoVisible, setModalPDFPagoVisible] = useState(false);
  const [modalConcesionadoVisible, setModalConcesionadoVisible] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingValidacion, setLoadingValidacion] = useState(false);
  const [loadingFactura, setLoadingFactura] = useState(false);
  const [loadingEliminar, setLoadingEliminar] = useState(false);
  const [loadingHistorial, setLoadingHistorial] = useState(false);
  const [loadingArchivar, setLoadingArchivar] = useState(false);
  const [loadingAdminOverride, setLoadingAdminOverride] = useState(false);
  const [loadingRechazar, setLoadingRechazar] = useState(false)
  const [modalRechazarVisible, setModalRechazarVisible] =useState(false)
  const [modalAdminOverrideVisible, setModalAdminOverrideVisible] = useState(false);
   const [modalTareasVisible, setModalTareasVisible] = useState(false)
    const [tareasEnProceso, setTareasEnProceso] = useState(0)
    const [emails, setEmails] = useState('');

   useEffect(() => {
     if (ordenPagoID) {
       dispatch(startGetOrdenPagoV2(ordenPagoID)).finally(() => {
         setIsInitialLoad(false);
       });
       dispatch(startGetTareasOp(ordenPagoID)).then(result => {
         if (result.success) {
           setTareasEnProceso(result.data.filter(t => !t.fechaConcluido).length)
         }
       });
     }
    }, [dispatch, ordenPagoID]);


   const timeline = useMemo(() =>
    getTimeline(ordenPago?.estatusOrdenPagoID, ordenPago),
    [ordenPago]
  );

  const handleAgregarHistorial = async () => {
    if (!nuevoComentario.trim()) return;

    const body = {
      ordenPagoID,
      comentario: nuevoComentario,
      notificarRedProveedores: notificarRedProveedores
    };

    setLoadingHistorial(true);

    try {
      await dispatch(startAddHistorialOrdenPago(body));
      setNuevoComentario('');
      setNotificarRedProveedores(false);
    } finally {
      setLoadingHistorial(false);
    }
  };

  const handleEnviarEmail = async (emailsString) => {
    if (!emailsString || !emailsString.trim()) return;

    setLoadingEmail(true);

    try {
      await executeWithReload(
        () => dispatch(startEnviarOpPorEmail(ordenPagoID, emailsString)),
        () => {
          setModalEmailVisible(false);
          setEmails('');
        }
      );
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleAutorizar1 = () =>
    executeWithReload(() => dispatch(startAutorizaOPv2(ordenPagoID)));

  const handleAutorizar2 = () =>
    executeWithReload(() => dispatch(startAutorizaOP2v2(ordenPagoID)));

  const handleAutorizar3 = () =>
    executeWithReload(() => dispatch(startAutorizaOP3v2(ordenPagoID)));

  const handleAvanzarOP = () =>
    executeWithReload(() => dispatch(startAvanzarPagoDirectoOP(ordenPagoID)));

  const handleDescargarXLS = () => {
    dispatch(startGetOrdenPagoItemsXLS(ordenPagoID));
  };

  const handleDescargarOP = async () => {
    await dispatch(startDownloadOPv2(ordenPagoID));
  };

  const handleDescargarDocumento = async (tipo) => {
    await dispatch(startDownloadDocumentoOP(ordenPagoID, tipo));
  };

  const handleDescargarCSF = async () => {
    if (ordenPago?.proveedorID) {
      await dispatch(startDownloadCSF(ordenPago.proveedorID));
    }
  };

  const handleDescargarCaratula = async () => {
    if (ordenPago?.proveedorID) {
      await dispatch(startDownloadCaratula(ordenPago.proveedorID));
    }
  };

  const handleConfirmarFactura = async () => {
    setLoadingValidacion(true);
    try {
      await executeWithReload(
        () => dispatch(startMarcarEstatus({ ordenPagoID, estatusOrdenPagoID: 4 }))
      );
    } finally {
      setLoadingValidacion(false);
    }
  };

  const handleValidarFactura = async () => {
    setLoadingValidacion(true);
    try {
      await executeWithReload(
        () => dispatch(startValidarDocumentos(ordenPagoID, true, "")),
        () => setModalValidarFacturaVisible(false)
      );
    } finally {
      setLoadingValidacion(false);
    }
  };

  const handleRechazarFactura = async (mensajeRechazo) => {
    setLoadingValidacion(true);
    try {
      await executeWithReload(
        () => dispatch(startValidarDocumentos(ordenPagoID, false, mensajeRechazo)),
        () => setModalValidarFacturaVisible(false)
      );
    } finally {
      setLoadingValidacion(false);
    }
  };

  const handleCloseModalValidarFactura = () => {
    setModalValidarFacturaVisible(false);
  };

  const handleUpdateItem = (ordenPagoItemID, values) => {
    const item = ordenPagoItems.find(i => i.ordenPagoItemID === ordenPagoItemID);
    if (!item) return;

    const body = {
      ordenPagoItemID,
      iva: item.iva || 0,
      ivaRetenido: values.ivaRetenido || 0,
      isrRetenido: values.isrRetenido || 0,
      monto: item.monto || 0,
      ordenPagoID,
      asistenciaID: item.asistenciaID,
      claveSAT: values.sat ?? item.claveSAT
    };

    return executeWithReload(() => dispatch(startUpdateOrdenPagoRowAndReload(body, ordenPagoID)));
  };

  const handleAgregarServicio = (asistenciaID) => {
    const body = {
      asistenciaID,
      ordenPagoID,
      usuarioID
    };

    executeWithReload(() => dispatch(startAddOrdenPagoRowAndReload(body)));
  };

  const handleEliminarServicio = (ordenPagoItemID) => {
    executeWithReload(() => dispatch(startDeleteOrdenPagoRowAndReload(ordenPagoItemID, ordenPagoID)));
  };

  const handleFacturaPagada = () =>
    executeWithReload(() => dispatch(startUpdateEstadoPago(ordenPagoID)));

  const handleArchivar = () => {
    setLoadingArchivar(true);
    const archivado = !ordenPago?.archivado;
    dispatch(startSetOpArchivado(ordenPagoID, archivado))
      .then((result) => {
        if (result.success) {
          return dispatch(startGetOrdenPagoV2(ordenPagoID));
        }
      })
      .finally(() => {
        setLoadingArchivar(false);
      });
  };

  const handleComplementoSuccess = () =>
    executeWithReload(() => Promise.resolve());

  const handleXLSXPagoSuccess = () =>
    executeWithReload(() => Promise.resolve(), () => setModalXLSXPagoVisible(false));

  const handlePDFPagoSuccess = () =>
    executeWithReload(() => Promise.resolve(), () => setModalPDFPagoVisible(false));

  const handleCargarFacturaSuccess = () =>
    executeWithReload(() => Promise.resolve(), () => {
      setModalFacturaVisible(false);
      setLoadingFactura(false);
    });

  const handleRegresoFlujo = () =>
    executeWithReload(() => dispatch(startRegresoFlujoOp(ordenPagoID)));

  const handleDescargarDocumentoConcesionados = async () => {
    await dispatch(startDescargarDocumentoConcesionados(ordenPagoID));
  };

  const handleConcesionadoSuccess = () =>
    executeWithReload(() => Promise.resolve(), () => setModalConcesionadoVisible(false));

  const handleEliminarOP = async () => {
    setLoadingEliminar(true);

    try {
      const result = await dispatch(startEliminarOP(ordenPagoID));

      if (result.success) {
        history.push('/ordenesPagoV2');
      }
    } finally {
      setLoadingEliminar(false);
    }
  };

   const handleAjustarCliente = () =>
     executeWithReload(() => dispatch(startSetClienteEnOp(ordenPagoID)));

   const handleAjustarAnaliticaOdoo = () =>
     executeWithReload(() => dispatch(startSetAnaliticaOdoo(ordenPagoID)));

  const handleAdminStatusOverride = async (nuevoEstatus, brincar) => {
    setLoadingAdminOverride(true);
    try {
      await executeWithReload(
        () => dispatch(startAdminStatusOverride(ordenPagoID, nuevoEstatus, brincar)),
        () => {
          setModalAdminOverrideVisible(false);
        }
      );
    } finally {
      setLoadingAdminOverride(false);
    }
  };

  const handleRechazarOp = async (motivoRechazo) => {
    setLoadingRechazar(true)
    try {
      await executeWithReload(
        () => dispatch(startValidarDocumentos(ordenPagoID, false, motivoRechazo)),
        () => {
          setModalRechazarVisible(false)
        }
      )
    } finally {
      setLoadingRechazar(false)
    }
  }

  const timelineProps = useMemo(() => ({
    timeline,
    estatusActual: ordenPago?.estatusOrdenPagoID || 0,
    onRegresoFlujo: handleRegresoFlujo,
    onEliminarOP: handleEliminarOP,
    loadingEliminar
  }), [timeline, ordenPago?.estatusOrdenPagoID, loadingEliminar]);

  const datosPrincipalesProps = useMemo(() => ({
    ordenPago,
    onAutorizar1: handleAutorizar1,
    onAutorizar2: handleAutorizar2,
    onAutorizar3: handleAutorizar3,
    onAvanzarOP: handleAvanzarOP,
    onSolicitarFactura: () => setModalEmailVisible(true),
    onCargarFactura: () => setModalFacturaVisible(true),
    onValidarFactura: () => setModalValidarFacturaVisible(true),
    onFacturaPagada: handleFacturaPagada,
    onCargarComplemento: () => setModalComplementoVisible(true),
    onCargarXLSXPago: () => setModalXLSXPagoVisible(true),
    onCargarPDFPago: () => setModalPDFPagoVisible(true),
    onCargarDocumentoConcesionados: () => setModalConcesionadoVisible(true),
    onConfirmarFactura: handleConfirmarFactura,
    onDescargarOP: handleDescargarOP,
    onDescargarDocumento: handleDescargarDocumento,
    onDescargarCSF: handleDescargarCSF,
     onDescargarCaratula: handleDescargarCaratula,
     onDescargarDocumentoConcesionados: handleDescargarDocumentoConcesionados,
      onArchivar: handleArchivar,
      onAjustarCliente: handleAjustarCliente,
      onAjustarAnaliticaOdoo: handleAjustarAnaliticaOdoo,
      loadingAnaliticaOdoo: loadingAutorizaciones,
      onAdminStatusOverride: () => setModalAdminOverrideVisible(true),
      onRechazarOp: () => setModalRechazarVisible(true),
      loadingArchivar
    }), [ordenPago, loadingArchivar, loadingAutorizaciones]);

  const historialProps = useMemo(() => ({
    historial: ordenPago?.ordenPagoHistorial || [],
    nuevoComentario,
    setNuevoComentario,
    notificarRedProveedores,
    setNotificarRedProveedores,
    onAgregarHistorial: handleAgregarHistorial,
    loadingHistorial,
    onAbrirTareas: () => setModalTareasVisible(true),
    tareasEnProceso
  }), [ordenPago?.ordenPagoHistorial, nuevoComentario, notificarRedProveedores, loadingHistorial, tareasEnProceso]);

  const tablaServiciosProps = useMemo(() => {
    const serviciosMapeados = (ordenPagoItems || []).map(item => ({
      ...item,
      fecha: item.fechaLlamadaIniciada,
      sat: item.claveSAT,
      estatusFinalNombre: item.estatusFinal,
      tienePlaca: item.tienePlaca
    }));

    return {
      servicios: serviciosMapeados,
      total: ordenPago?.total || 0,
      numeroServicios: ordenPago?.numeroServicios || ordenPagoItems?.length || 0,
      onDescargarXLS: handleDescargarXLS,
      onUpdateItem: handleUpdateItem,
      onAgregarServicio: handleAgregarServicio,
      onEliminarServicio: handleEliminarServicio,
      proveedorID: ordenPago?.proveedorID || null,
      ordenPagoID,
      estatusOrdenPagoID: ordenPago?.estatusOrdenPagoID || 0,
      estaRechazada: !!ordenPago?.estaRechazada,
      documentosAsistencia: ordenPago?.documentosAsistencia || []
    };
  }, [ordenPagoItems, ordenPago?.total, ordenPago?.numeroServicios, ordenPago?.estatusOrdenPagoID, ordenPago?.proveedorID, ordenPago?.estaRechazada, ordenPagoID]);

  const modalEmailProps = useMemo(() => ({
    visible: modalEmailVisible,
    onClose: () => setModalEmailVisible(false),
    emails,
    setEmails,
    onEnviar: handleEnviarEmail,
    loading: loadingEmail,
    proveedorEmail: ordenPago?.proveedorEmail || ''
  }), [modalEmailVisible, emails, loadingEmail, ordenPago?.proveedorEmail]);

  const modalFacturaProps = useMemo(() => ({
    visible: modalFacturaVisible,
    onClose: () => setModalFacturaVisible(false),
    ordenPagoID,
    loading: loadingFactura,
    setLoading: setLoadingFactura,
    onSuccess: handleCargarFacturaSuccess
  }), [modalFacturaVisible, ordenPagoID, loadingFactura]);

  const modalValidarFacturaProps = useMemo(() => ({
    visible: modalValidarFacturaVisible,
    onClose: handleCloseModalValidarFactura,
    onValidar: handleValidarFactura,
    onRechazar: handleRechazarFactura,
    loading: loadingValidacion
  }), [modalValidarFacturaVisible, loadingValidacion]);

  const modalComplementoProps = useMemo(() => ({
    visible: modalComplementoVisible,
    onClose: () => setModalComplementoVisible(false),
    ordenPagoID,
    onSuccess: handleComplementoSuccess
  }), [modalComplementoVisible, ordenPagoID]);

  const modalXLSXPagoProps = useMemo(() => ({
    visible: modalXLSXPagoVisible,
    onClose: () => setModalXLSXPagoVisible(false),
    ordenPagoID,
    onSuccess: handleXLSXPagoSuccess
  }), [modalXLSXPagoVisible, ordenPagoID]);

  const modalRechazarProps = useMemo(() => ({
    visible: modalRechazarVisible,
    onClose: () => setModalRechazarVisible(false),
    onConfirm: handleRechazarOp,
    loading: loadingRechazar
  }), [modalRechazarVisible, loadingRechazar])

  const modalPDFPagoProps = useMemo(() => ({
    visible: modalPDFPagoVisible,
    onClose: () => setModalPDFPagoVisible(false),
    ordenPagoID,
    onSuccess: handlePDFPagoSuccess
  }), [modalPDFPagoVisible, ordenPagoID]);

  const modalConcesionadoProps = useMemo(() => ({
    visible: modalConcesionadoVisible,
    onClose: () => setModalConcesionadoVisible(false),
    ordenPagoID,
    onSuccess: handleConcesionadoSuccess,
    autorizacionClienteUri: ordenPago?.autorizacionClienteUri,
    facturaUri: ordenPago?.facturaUri,
    facturaXMLUri: ordenPago?.facturaXMLUri,
    verificacionFacturaUri: ordenPago?.verificacionFacturaUri
  }), [modalConcesionadoVisible, ordenPagoID, ordenPago?.autorizacionClienteUri, ordenPago?.facturaUri, ordenPago?.facturaXMLUri, ordenPago?.verificacionFacturaUri]);

  const modalAdminOverrideProps = useMemo(() => ({
    visible: modalAdminOverrideVisible,
    onClose: () => setModalAdminOverrideVisible(false),
    onConfirm: handleAdminStatusOverride,
    loading: loadingAdminOverride,
    estatusActual: ordenPago?.estatusOrdenPagoID || 0
  }), [modalAdminOverrideVisible, loadingAdminOverride, ordenPago?.estatusOrdenPagoID]);

  const modalTareasProps = useMemo(() => ({
    visible: modalTareasVisible,
    onClose: () => setModalTareasVisible(false),
    ordenPagoID,
    onTareasChange: setTareasEnProceso
  }), [modalTareasVisible, ordenPagoID])

    return {
    ordenPago,
    loadingAutorizaciones: isInitialLoad || loadingAutorizaciones,
    timelineProps,
    datosPrincipalesProps,
    historialProps,
    tablaServiciosProps,
    modalTareasProps,
    modalEmailProps,
    modalFacturaProps,
    modalValidarFacturaProps,
    modalComplementoProps,
    modalXLSXPagoProps,
    modalPDFPagoProps,
    modalConcesionadoProps,
    modalAdminOverrideProps,
    modalRechazarProps
  };
};
